function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import EdgeEnd from '../../geomgraph/EdgeEnd';
import Label from '../../geomgraph/Label';
import ArrayList from '../../../../../java/util/ArrayList';
var EdgeEndBuilder = /*#__PURE__*/function () {
  function EdgeEndBuilder() {
    _classCallCheck(this, EdgeEndBuilder);
    EdgeEndBuilder.constructor_.apply(this, arguments);
  }
  return _createClass(EdgeEndBuilder, [{
    key: "createEdgeEndForNext",
    value: function createEdgeEndForNext(edge, l, eiCurr, eiNext) {
      var iNext = eiCurr.segmentIndex + 1;
      if (iNext >= edge.getNumPoints() && eiNext === null) return null;
      var pNext = edge.getCoordinate(iNext);
      if (eiNext !== null && eiNext.segmentIndex === eiCurr.segmentIndex) pNext = eiNext.coord;
      var e = new EdgeEnd(edge, eiCurr.coord, pNext, new Label(edge.getLabel()));
      l.add(e);
    }
  }, {
    key: "createEdgeEndForPrev",
    value: function createEdgeEndForPrev(edge, l, eiCurr, eiPrev) {
      var iPrev = eiCurr.segmentIndex;
      if (eiCurr.dist === 0.0) {
        if (iPrev === 0) return null;
        iPrev--;
      }
      var pPrev = edge.getCoordinate(iPrev);
      if (eiPrev !== null && eiPrev.segmentIndex >= iPrev) pPrev = eiPrev.coord;
      var label = new Label(edge.getLabel());
      label.flip();
      var e = new EdgeEnd(edge, eiCurr.coord, pPrev, label);
      l.add(e);
    }
  }, {
    key: "computeEdgeEnds",
    value: function computeEdgeEnds() {
      if (arguments.length === 1) {
        var edges = arguments[0];
        var l = new ArrayList();
        for (var i = edges; i.hasNext();) {
          var e = i.next();
          this.computeEdgeEnds(e, l);
        }
        return l;
      } else if (arguments.length === 2) {
        var edge = arguments[0];
        var _l = arguments[1];
        var eiList = edge.getEdgeIntersectionList();
        eiList.addEndpoints();
        var it = eiList.iterator();
        var eiPrev = null;
        var eiCurr = null;
        if (!it.hasNext()) return null;
        var eiNext = it.next();
        do {
          eiPrev = eiCurr;
          eiCurr = eiNext;
          eiNext = null;
          if (it.hasNext()) eiNext = it.next();
          if (eiCurr !== null) {
            this.createEdgeEndForPrev(edge, _l, eiCurr, eiPrev);
            this.createEdgeEndForNext(edge, _l, eiCurr, eiNext);
          }
        } while (eiCurr !== null);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { EdgeEndBuilder as default };
EdgeEndBuilder.constructor_ = function () {};